const commonMoney = [
  {
    label: 'Até R$ 1.200,00',
    value: 'Até R$ 1.200,00',
  },
  {
    label: 'De Até R$ 1.200,01 Até R$ 10.499,99',
    value: 'De Até R$ 1.200,01 Até R$ 10.499,99',
  },
  {
    label: 'De Até R$ 10.500,00 Até R$ 60.000,00',
    value: 'De Até R$ 10.500,00 Até R$ 60.000,00',
  },
  {
    label: 'Acima de R$ 60.000,00',
    value: 'Acima de R$ 60.000,00',
  },
]

export const incomes = [
  {
    label: 'Não desejo informar',
    value: 'Não desejo informar',
  },
  ...commonMoney,
  {
    label: 'Sem rendimentos mensais',
    value: 'Sem rendimentos mensais',
  },
]

export const assets = [
  {
    label: 'Não desejo informar',
    value: 'Não desejo informar',
  },
  ...commonMoney,
  {
    label: 'Sem patrimônio',
    value: 'Sem patrimônio',
  },
]

export const relationship_degree = [
  {
    label: 'Selecione o grau de parentesco',
    value: '',
  },
  {
    label: 'Pai ou mãe',
    value: 'Pai ou mãe',
  },
  {
    label: 'Cônjuge',
    value: 'Cônjuge',
  },
  {
    label: 'Companheiro(a)',
    value: 'Companheiro(a)',
  },
  {
    label: 'Filho(a)',
    value: 'Filho(a)',
  },
  {
    label: 'Enteado(a)',
    value: 'Enteado(a)',
  },
  {
    label: 'Outro',
    value: 'Outro',
  },
]
